import React from "react";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import FormInput from "../../../../../components/Universal/FormInput.component";
import { Formik } from "formik";
import CustomBill from "../../../../../components/Universal/CustomBill.component";
import VendorPaymentValidation from "../../../../../components/PagesComponents/Financial/CashOutFlow/AcademicEx/MaterialAndResources/VendorPaymentValidation.component";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import "../../../../../styles/Pages/Financial/CashOutFlow/AcademicEx/MaterialAndResources.style.css";
import AcademicUniversalTable from "../../../../../components/Universal/Tables/AcademicUniversalTable.component";
import UniversalTable from "../../../../../components/Universal/Tables/UniversalTable.component";

const Body = ({
  vehicles,
  vehicleHeaders,
  transportTableData,
  columns,
  confirmedByOptions,
  paymentModes,
}) => {
  const [isReceiptOpen, setIsReceiptOpen] = React.useState(false);
  const [checkedItems, setCheckedItems] = React.useState({});
  const [selectedData, setSelectedData] = React.useState([]);
  const [submittedValues, setSubmittedValues] = React.useState(null);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [showHistory, setShowHistory] = React.useState(false);

  // 👇 tax percentage state
  const [taxPercent, setTaxPercent] = React.useState(10);

  const handleSelectAll = () => {
    const allSelected = Object.keys(checkedItems).length === vehicles.length;
    if (allSelected) {
      setCheckedItems({});
      setSelectedData([]);
    } else {
      const newChecked = {};
      const newSelected = vehicles.map((item) => {
        newChecked[item.itemCode] = true;
        return { ...item }; // copy so we can edit dueAmount
      });
      setCheckedItems(newChecked);
      setSelectedData(newSelected);
    }
  };

  const handleSingleCheck = (itemCode, item) => {
    const updated = { ...checkedItems };
    const isChecked = !!updated[itemCode];

    if (isChecked) {
      delete updated[itemCode];
      setSelectedData((prev) => prev.filter((d) => d.itemCode !== itemCode));
    } else {
      updated[itemCode] = true;
      setSelectedData((prev) => [...prev, { ...item }]); // copy
    }

    setCheckedItems(updated);
  };

  // 👇 update row dueAmount
  const handleAmountChange = (itemCode, newAmount) => {
    setSelectedData((prev) =>
      prev.map((item) =>
        item.itemCode === itemCode
          ? { ...item, dueAmount: Number(newAmount) || 0 }
          : item
      )
    );
  };

  // 👇 recalculate subtotal dynamically
  const subtotal = React.useMemo(() => {
    return selectedData.reduce(
      (acc, item) => acc + (Number(item?.dueAmount) || 0),
      0
    );
  }, [selectedData]);

  const taxAmount = React.useMemo(
    () => (subtotal * taxPercent) / 100,
    [subtotal, taxPercent]
  );
  const netTotal = React.useMemo(
    () => subtotal + taxAmount,
    [subtotal, taxAmount]
  );

  if (showHistory)
    return (
      <section className="TransportCostHistorySection">
        <ScrollableModal
          isOpen={isReceiptOpen}
          onClose={() => setIsReceiptOpen(!isReceiptOpen)}
        >
          {isReceiptOpen && (
            <CustomBill data={selectedData} vendorInfo={submittedValues} />
          )}
        </ScrollableModal>
        <Helmet>
          <title>All payments history</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="All payments history, cash outflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        <PageHeader title={"All payments history"} />
        <div
          style={{
            marginTop: "1rem",
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "10px",
          }}
          className="HistorySection"
        >
          <div className="history-header mb-1">
            <h3
              style={{
                color: "var(--grayColor)",
                fontWeight: "500",
                marginBottom: "0.5rem",
              }}
            >
              All Transport payment history
            </h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="inputs-buttons"
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                className="input"
              >
                <div className="searchInputContainer">
                  <button className="searchBtn">
                    <img src={SearchIcon} alt="Search" />
                  </button>
                  <input
                    type="text"
                    className="pageHeaderInput"
                    placeholder="Search id"
                  />
                </div>
                <DatePicker
                  label=""
                  name="date"
                  setFieldValue={() => {}}
                  placeholder={"Choose a date"}
                  errors={() => {}}
                />
              </div>
              <div style={{ display: "flex", gap: "1rem" }} className="buttons">
                <button
                  style={{
                    backgroundColor: "var(--blueColor1)",
                    borderColor: "var(--blueColor1)",
                  }}
                  onClick={() => setShowHistory(false)}
                  className="actionBtn"
                >
                  Go to transportation cost
                </button>
                <button className="actionBtn">Download</button>
              </div>
            </div>
          </div>
          <div className="history-table">
            <UniversalTable
              columns={columns}
              data={transportTableData}
              maxBodyHeight="340px"
              footer={
                <div className="Amount-Indicators">
                  <div className="indicator-group">
                    <span className="indicator-box filled-orange">
                      Total count: <span className="text-white">236</span>
                    </span>

                    <span className="indicator-box outlined-orange">
                      Due amount: <span className="text-orange">₹ 2,60,560</span>
                    </span>
                  </div>

                  <div className="indicator-group">
                    <span className="indicator-box outlined-blue">
                      Total amounts:{" "}
                      <span className="text-blue-light">₹ 2,60,560</span>
                    </span>

                    <span className="indicator-box filled-blue">
                      Paid amount: <span className="text-white">₹ 2,60,560</span>
                    </span>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </section>
    );

  return (
    <section className="TransportCostSection">
      <ScrollableModal
        isOpen={isReceiptOpen}
        onClose={() => setIsReceiptOpen(!isReceiptOpen)}
      >
        {isReceiptOpen && (
          <CustomBill data={selectedData} vendorInfo={submittedValues} />
        )}
      </ScrollableModal>
      <Helmet>
        <title>Transportation cost</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="Transportation cost,cash outflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Transportation cost"} />
      <div className="MaterialAndResourceContaienr">
        <div className="left">
          <AcademicUniversalTable
            title="List of due payment: Transportational systems"
            headers={vehicleHeaders}
            data={vehicles}
            showCheckbox={true}
            checkedItems={checkedItems}
            onSelectAll={handleSelectAll}
            onRowSelect={handleSingleCheck}
          />
        </div>
        <div className="right">
          <div className="content-header">
            <h3>Confirmation of Payment</h3>
            <button
              onClick={() => setShowHistory(true)}
              className="blueActionBtnLight"
            >
              All Payments History
            </button>
          </div>

          {showSuccess ? (
            <div className="billSuccess">
              <h2>You have confirm payment successfully</h2>
              <p>Receipt ID: 23456789012</p>
              <h4 onClick={() => setIsReceiptOpen(true)}>
                Receipt <BsBoxArrowRight />
              </h4>
              <button
                onClick={() => setShowSuccess(false)}
                className="actionBtn"
              >
                Okay
              </button>
            </div>
          ) : (
            selectedData.length > 0 && (
              <>
                <div className="bill-table-container">
                  <table className="bill-table">
                    <thead>
                      <tr>
                        <th>Vehicle No.({selectedData.length})</th>
                        <th>Route No.</th>
                        <th>Reported by</th>
                        <th>Amount (INR)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedData.map((item) => (
                        <tr key={item.itemCode}>
                          <td>{item?.vehicleNo}</td>
                          <td>{item?.routeNo}</td>
                          <td className="reporter">{item.reporter}</td>
                          <td>
                            <span className="totalAmount">
                              <span className="rupeeSymbol">₹</span>
                              <input
                                style={{
                                  outline: "none",
                                  border: "none",
                                  backgroundColor: "transparent",
                                  width: "80px",
                                  marginInline: "auto",
                                  height: "24px",
                                }}
                                type="number"
                                value={item?.dueAmount}
                                onChange={(e) =>
                                  handleAmountChange(item.itemCode, e.target.value)
                                }
                                className="totalAmountInput"
                              />
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="totalContainer">
                  <div className="subSection">
                    <div className="subTotal">
                      <span>Sub Total:</span>
                      <span>₹ {subtotal}</span>
                    </div>
                    <div className="taxes">
                      <span>Other tax (GST, SGST, CGST) in %</span>
                      <span className="taxPercentage">
                        <input
                          style={{
                            outline: "none",
                            border: "none",
                            backgroundColor: "transparent",
                            width: "40px",
                            marginInline: "auto",
                            height: "24px",
                          }}
                          type="number"
                          value={taxPercent}
                          onChange={(e) =>
                            setTaxPercent(Number(e.target.value) || 0)
                          }
                        />
                      </span>
                      <span>₹ {taxAmount}</span>
                    </div>
                  </div>
                  <div className="netTotal">
                    <span>Total:</span>
                    <span>₹ {netTotal}</span>
                  </div>
                </div>
                <div className="formContaienr">
                  <Formik
                    initialValues={{
                      vendorName: "",
                      vendorContact: "",
                      paidAmount: "",
                      confirmedBy: "",
                      paymentMode: "",
                    }}
                    validationSchema={VendorPaymentValidation}
                    onSubmit={(values) => {
                      console.log("Form Submitted:", values);
                      setSubmittedValues(values);
                      setShowSuccess(true);
                    }}
                  >
                    {({
                      setFieldValue,
                      handleSubmit,
                      touched,
                      errors,
                      setTouched,
                    }) => (
                      <form
                        onSubmit={handleSubmit}
                        className="vendorPaymentForm"
                      >
                        <div className="vendorPaymentFormInputs">
                          <FormInput
                            label="Vendor name"
                            type="text"
                            name="vendorName"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter vendor name"
                            setFieldValue={(e) =>
                              setFieldValue("vendorName", e.target.value)
                            }
                          />

                          <FormInput
                            label="Vendor contact"
                            type="text"
                            name="vendorContact"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter vendor contact number"
                            setFieldValue={(e) =>
                              setFieldValue("vendorContact", e.target.value)
                            }
                          />

                          <FormInput
                            label="Paid amount (INR)"
                            type="number"
                            name="paidAmount"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter paid amount"
                            setFieldValue={(e) =>
                              setFieldValue("paidAmount", e.target.value)
                            }
                          />

                          <DropDownInput
                            name="confirmedBy"
                            label="Confirmed by"
                            placeholder="Choose confirmed by"
                            suggestionList={confirmedByOptions}
                            setFieldValue={(val) =>
                              setFieldValue("confirmedBy", val)
                            }
                            touched={touched}
                            errors={errors}
                            setTouched={(name, isTouched) =>
                              setTouched({ [name]: isTouched })
                            }
                          />

                          <DropDownInput
                            name="paymentMode"
                            label="Payment mode"
                            placeholder="Choose payment mode"
                            suggestionList={paymentModes}
                            setFieldValue={(val) =>
                              setFieldValue("paymentMode", val)
                            }
                            touched={touched}
                            errors={errors}
                            setTouched={(name, isTouched) =>
                              setTouched({ [name]: isTouched })
                            }
                          />
                        </div>

                        <button
                          type="submit"
                          className="confirmPaymentBtn actionBtn"
                        >
                          Confirm payment
                        </button>
                      </form>
                    )}
                  </Formik>
                </div>
              </>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Body;
